import { ApiOnboardingStep } from "@incendium/api";
import OnboardingLayout from "features/onboarding/components/OnboardingLayout";
import {
  getEcomPlatformStepNumber,
  normalizeEcomPlatformStep,
} from "features/onboarding/ecomPlatform/constants";
import { EcomPlatformOnboardingConfig } from "features/onboarding/ecomPlatform/types";
import { ReactNode } from "react";

interface IEcomPlatformOnboardingLayoutProps {
  config: EcomPlatformOnboardingConfig;
  step: ApiOnboardingStep;
  onBack?: () => void;
  showBack?: boolean;
  children: ReactNode;
}

function EcomPlatformOnboardingLayout({
  config,
  step,
  onBack,
  showBack = true,
  children,
}: IEcomPlatformOnboardingLayoutProps) {
  const normalizedStep = normalizeEcomPlatformStep(config, step);
  const stepNumber = getEcomPlatformStepNumber(config, normalizedStep);
  const panel = config.leftPanel[normalizedStep];

  return (
    <OnboardingLayout
      stepNumber={stepNumber}
      totalSteps={config.totalSteps}
      panel={{
        heading: panel?.heading ?? "",
        headingAccent: panel?.headingAccent,
        paragraphs: panel?.paragraphs ?? [],
      }}
      onBack={onBack}
      showBack={showBack}
    >
      {children}
    </OnboardingLayout>
  );
}

export default EcomPlatformOnboardingLayout;
